<div class="container-box">
  <app-table-header
    tableTitle="Obiettivi marca"
    (btnUpdateClick)="loadBrandGoals()"
  ></app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="brandGoalsTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
